import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { taskListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useTaskList from './hooks';
import styles from './TaskList.module.scss';

function TaskList({ taskReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useTaskList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={taskReports}
        headers={taskListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

TaskList.propTypes = {
  taskReports: PropTypes.arrayOf(
    PropTypes.shape({
      procedureCode: PropTypes.string,
      taskID: PropTypes.string,
      taskName: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

TaskList.defaultProps = {
  taskReports: [],
  loading: false,
};

export default TaskList;
